export interface LinkedPartGroupRouterGroupLineData {
	linkGroupId: number;
	partId: number;
	stageNumber: number;
}

export class LinkedPartGroupRouterGroupLineData implements LinkedPartGroupRouterGroupLineData {
	constructor(data?: Partial<LinkedPartGroupRouterGroupLineData>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}